import React from 'react';
import styles from './styles.module.css';
import parts from '../moduleCard/moduleParts.module.css';
import maleFigure from '../../../../assets/images/body/silhouette-male.png';

// Linha do tempo ilustrativa: da sessão mais recente para a mais antiga
const EXAMPLE_SESSIONS = [
  { date: '12/03/2026', current: true, thumbs: [{ mark: 'D' }, {}] },
  { date: '12/01/2026', current: false, thumbs: [{ mark: 'A' }, {}] },
];

const EXAMPLE_FRAMES = [
  { badge: 'Antes', date: '12/01/2026', active: false },
  { badge: 'Depois', date: '12/03/2026', active: true },
];

/**
 * Estado vazio do módulo: o layout real em miniatura (linha do tempo à
 * esquerda, comparação à direita) com a silhueta no lugar das fotos,
 * esmaecido e marcado como exemplo. Nada aqui é clicável nem gravado; some ao
 * enviar a primeira foto real.
 */
const EvolutionPhotosExample = ({ enabled }) => (
  <div className={styles.example} aria-label="Exemplo de comparação, sem fotos do paciente">
    <div className={styles.exampleHead}>
      <span className={`${parts.chip} ${parts.chipAccent}`}>Exemplo</span>
      <span className={parts.muted}>
        {enabled
          ? 'Nenhuma foto registrada. Assim fica a comparação depois de duas sessões: envie as fotos com região e ângulo.'
          : 'Nenhuma foto de evolução registrada para este paciente.'}
      </span>
    </div>

    <div className={styles.exampleBody} aria-hidden="true">
      <div className={styles.exampleTimeline}>
        {EXAMPLE_SESSIONS.map((session) => (
          <div
            key={session.date}
            className={`${styles.timelineSession} ${session.current ? styles.timelineSessionCurrent : ''}`}
          >
            <div className={styles.timelineHead}>
              <span className={styles.timelineDate}>{session.date}</span>
              {session.current && <span className={styles.sessionTag}>Este atendimento</span>}
            </div>
            <div className={styles.timelineThumbs}>
              {session.thumbs.map((thumb, index) => (
                <span key={index} className={`${styles.exampleThumb} ${thumb.mark ? styles.exampleThumbSelected : ''}`}>
                  <img src={maleFigure} alt="" />
                  {thumb.mark && <span className={styles.timelineMark}>{thumb.mark}</span>}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.exampleFrames}>
        {EXAMPLE_FRAMES.map((frame) => (
          <div key={frame.badge} className={styles.exampleFrame}>
            <div className={`${styles.sideHead} ${frame.active ? styles.sideHeadActive : ''}`}>
              <span className={styles.sideSelect}>
                <span className={styles.sideBadge}>{frame.badge}</span>
                <span className={styles.sideDate}>{frame.date}</span>
                <span className={styles.sideLabel}>Abdômen · Frente</span>
              </span>
            </div>
            <div className={styles.examplePhoto}>
              <img src={maleFigure} alt="" />
            </div>
          </div>
        ))}
      </div>
    </div>

    {enabled && (
      <div className={styles.exampleSteps}>
        <span>1. Adicione as fotos do atendimento, uma ou várias de uma vez, direto da câmera do celular.</span>
        <span>2. Identifique a região e o ângulo para encontrar as fotos equivalentes depois.</span>
        <span>3. A mais antiga e a mais recente já aparecem comparadas; clique numa data para trocar.</span>
      </div>
    )}
  </div>
);

export default EvolutionPhotosExample;
